import React from "react";
import ReactDOM from "react-dom/client";
import { LicenseInfo } from '@mui/x-license';
import App from "src/App";
import { Provider } from "react-redux";
import store, { persistor } from "src/app/store";
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from "react-router-dom";
import "src/global.css";
import ThemeProvider from "src/theme";
import "src/locales/i18n";
import "src/assets/scss/main.scss";
import {
  SettingsProvider,
} from "src/components/shared-components/settings";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LocalizationProvider } from "./locales";
import { SnackbarProvider } from "./components/layout-components/snackbar";
import LoadingScreen from "./components/shared-components/loading-screen";
import { initSimpleAutoIdManager } from "./utils/autoIdManager";

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY || '');

export const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <SettingsProvider
    defaultSettings={{
      themeMode: "light", // 'light' | 'dark'
      themeDirection: "ltr", //  'rtl' | 'ltr'
      themeContrast: "default", // 'default' | 'bold'
      themeLayout: "vertical", // 'vertical' | 'horizontal' | 'mini'
      themeColorPresets: "default", // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
      themeStretch: false,
    }}
  >
    <ThemeProvider>
      <SnackbarProvider>
        <LocalizationProvider>
          <Provider store={store}>
            <PersistGate loading={<LoadingScreen />} persistor={persistor}>
              <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
              </QueryClientProvider>
            </PersistGate>
          </Provider>
        </LocalizationProvider>
      </SnackbarProvider>

    </ThemeProvider>
  </SettingsProvider>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
    }).catch(registrationError => {
    });
  });
}
if (process.env.REACT_APP_ACTIVATE_AUTO_IDS === "true") {
  initSimpleAutoIdManager("body");
}
